module.exports = __webpack_public_path__ + "img/jean-pierre-courtade.fcb4b054.jpg";